import { render, staticRenderFns } from "./CreateTradeContractForm.vue?vue&type=template&id=569225f3&scoped=true&"
import script from "./CreateTradeContractForm.vue?vue&type=script&lang=js&"
export * from "./CreateTradeContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569225f3",
  null
  
)

export default component.exports